import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import api from "../api/axiosInstance";
import MenuItemModal from "../components/MenuItemModal";
import "./MenuCategoryPage.css";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

export default function MenuCategoryPage() {
  const { category } = useParams();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  // filters
  const [search, setSearch] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");
  const [veganOnly, setVeganOnly] = useState(false);
  const [popularOnly, setPopularOnly] = useState(false);
  const [filtersOpen, setFiltersOpen] = useState(false); // <-- mobile toggle

  const [selected, setSelected] = useState(null);

  const fetchItems = async () => {
  try {
    setLoading(true);
    const params = { category };
    if (search) params.search = search;
    if (minPrice) params.minPrice = minPrice;
    if (maxPrice) params.maxPrice = maxPrice;
    if (veganOnly) params.vegan = "true";
    if (popularOnly) params.popular = "true";

    const { data } = await api.get("/menu", { params });
    setItems(data.menuItems || []);
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};


  // Redirect to "set" category if none provided
  useEffect(() => {
    if (!category) {
      navigate("/menu/set", { replace: true });
    }
  }, [category, navigate]);

  useEffect(() => {
  fetchItems();
}, [category, search, minPrice, maxPrice, veganOnly, popularOnly]);


  const handleClearFilters = () => {
    setSearch("");
    setMinPrice("");
    setMaxPrice("");
    setVeganOnly(false);
    setPopularOnly(false);
  };

  return (
    <>
      <Navbar />
      <div className="menu-category-page">
        <div className="menu-top">
          <div className="category-tabs">
            <button className={category === "set" ? "active" : ""} onClick={() => navigate("/menu/set")}>Set</button>
            <button className={category === "food" ? "active" : ""} onClick={() => navigate("/menu/food")}>Food</button>
            <button className={category === "dessert" ? "active" : ""} onClick={() => navigate("/menu/dessert")}>Dessert</button>
            <button className={category === "drink" ? "active" : ""} onClick={() => navigate("/menu/drink")}>Drinks</button>
          </div>

          {/* Mobile filter toggle */}
          <button className="filters-toggle-btn" onClick={() => setFiltersOpen(prev => !prev)}>
            {filtersOpen ? "Hide Filters" : "Show Filters"}
          </button>

          <div className={`menu-filters ${filtersOpen ? "open" : ""}`}>
            <input placeholder="Search items..." value={search} onChange={e => setSearch(e.target.value)} />
            <input type="number" placeholder="Min $" value={minPrice} onChange={e => setMinPrice(e.target.value)} />
            <input type="number" placeholder="Max $" value={maxPrice} onChange={e => setMaxPrice(e.target.value)} />
            <button className={veganOnly ? "filter-active" : ""} onClick={() => setVeganOnly(prev => !prev)}>Vegan</button>
            <button className={popularOnly ? "filter-active" : ""} onClick={() => setPopularOnly(prev => !prev)}>Popular</button>
            <button onClick={handleClearFilters}>Clear</button>
          </div>
        </div>

        <motion.div
          key={category}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
        >
          <div className="menu-grid">
            {items.map(item => (
              <div key={item._id} className="menu-card" onClick={() => setSelected(item)}>
                <div className="card-image" style={{ backgroundImage: `url(${item.imageUrl || "https://via.placeholder.com/360"})` }} />
                <div className="card-body">
                  <h3>{item.name}</h3>
                  <p className="muted">{item.description?.slice(0, 60)}</p>
                  <div className="card-footer">
                    <span className="price">${item.price?.toFixed(2)}</span>
                    <button className="select-btn">Select</button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {loading && <p style={{ textAlign: "center", marginTop: 20 }}>Loading...</p>}

        </motion.div>
      </div>

      {selected && <MenuItemModal item={selected} onClose={() => setSelected(null)} />}
      <Footer />
    </>
  );
}
